<ion-grid class="height-toolbar-2">

    <ion-row>

        <ion-segment scrollable (ionChange)="OnChangeStep($event)" [value]="SelectedTable">
            <ion-segment-button *ngFor="let config of Data" [value]="config?.ConfigTableName">
                {{ config?.ConfigTableName }}
            </ion-segment-button>
        </ion-segment>

    </ion-row>

    <ng-container *ngFor="let config of Data">

        <ion-row class="" [hidden]="SelectedTable !== config?.ConfigTableName">

            <ng-container [ngSwitch]="config?.ConfigTableName">

                <ng-container *ngSwitchCase="'CampaignConsumptionConfiguration'">

                    <table-campaign [data]="config"></table-campaign>

                </ng-container>

                <!-- EmailFieldsTemplate -->
                <ng-container *ngSwitchCase="'EmailFieldsTemplate'">

                    <table-email-fields [data]="config"></table-email-fields>

                </ng-container>

                <ng-container *ngSwitchCase="'EntityConfiguration'">
                    <table-entity-configuration [data]="config"></table-entity-configuration>
                </ng-container>

                <ng-container *ngSwitchCase="'EntityConfigurationOCR'">
                    <table-configuration-ocr [data]="config"></table-configuration-ocr>
                </ng-container>

                <ng-container *ngSwitchCase="'EntityConfigurationSSO'">
                    <table-configuration-sso [data]="config"></table-configuration-sso>
                </ng-container>

                <ng-container *ngSwitchCase="'EntityDetails'">
                    <table-entity-details [data]="config"></table-entity-details>
                </ng-container>

                <ng-container *ngSwitchCase="'PermissionTemplate'">
                    <table-permissions [data]="config"></table-permissions>
                </ng-container>


            </ng-container>

        </ion-row>

    </ng-container>


    <ion-row *ngIf="!Data || Data?.length == 0">
        <ion-col>
            <no-items></no-items>
        </ion-col>
    </ion-row>
</ion-grid>